import * as React from 'react'
import { useMemo } from 'react'
import { GroupedServices, ILeadOppProduct } from '@user/store/leadOppProducts'
import { selectAllServiceFrequencies } from '@user/store/serviceFrequency'
import { useSelector } from 'react-redux'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { DraggableAgreementServicesList } from './DraggableAgreementServicesList'

type Props = {
  type: string
  services: ILeadOppProduct[]
  getServiceLocationName: (locationId: string) => string
}

export function DraggableAgreementServicesListWrapper(props: Props) {
  const { services, type, getServiceLocationName } = props
  const serviceFrequencies = useSelector(selectAllServiceFrequencies)

  const groupedServices: GroupedServices[] = useMemo(() => {
    return services.reduce((acc: GroupedServices[], service) => {
      const { serviceLocationId } = service
      if (!serviceLocationId) return acc

      let group = acc.find(
        (item) => item.serviceLocationId === serviceLocationId,
      )

      if (!group) {
        group = { serviceLocationId, services: [] }
        acc.push(group)
      }

      group.services.push(service)

      return acc
    }, [] as GroupedServices[])
  }, [services])

  return (
    <>
      {groupedServices.map((group, index) => {
        return (
          <Stack
            key={`services-group-${index}`}
            sx={{
              paddingLeft: '20px',
              paddingRight: '11px',
              paddingTop: '14px',
              paddingBottom: '8px',
            }}
          >
            <Typography variant="body2" mb={1}>
              Service Location:{' '}
              {getServiceLocationName(group.serviceLocationId)}
            </Typography>

            <DraggableAgreementServicesList
              type={type}
              group={group}
              groupIndex={index}
              serviceFrequencies={serviceFrequencies}
              services={group.services}
            />
          </Stack>
        )
      })}
    </>
  )
}
